import { useGenerateSignedFileUrlMutation } from '../../generated/graphql';

export default useGenerateSignedFileUrlMutation;
